import {hydrate} from 'react-dom';
import {Provider} from 'mobx-react';
import {renderRoutes} from 'react-router-config';
import {Router} from 'react-router-dom';
import {syncHistoryWithStore } from 'mobx-react-router';
import base64 from 'base-64';
import createBrowserHistory from 'history/createBrowserHistory';
import Raven from 'raven-js';
import React from 'react';
import utf8 from 'utf8';

import RootStore from './modules/RootStore';
import routes from './routes.js';

import './print.scss';
import './style.scss';

if (module.hot) {
  module.hot.accept();
}

if (process.env.NODE_ENV === 'production') {
  Raven
    .config(process.env.RAVEN_URL)
    .install();
}

const bytes = base64.decode(window.__INITIAL_STATE__);
const text = utf8.decode(bytes);
const state = JSON.parse(text);
const rootStore = new RootStore(state);

const browserHistory = createBrowserHistory();
const history = syncHistoryWithStore(browserHistory, rootStore.routerStore);
history.subscribe(rootStore.watchHistory);

hydrate(
  (
    <Provider {...rootStore}>
      <Router history={history}>
        {renderRoutes(routes)}
      </Router>
    </Provider>
  ),
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./client/index.jsx